export class FileManager {
  constructor() {
    this.idCompany = "";
    this.infoCompanyFiles = [];
    this.sheetName = "";
    this.urlImg = "";
    this.urlFile = "";
  }

  getIdCompany() {
    return this.idCompany;
  }

  setIdCompany(idCompany) {
    this.idCompany = idCompany;
  }

  getInfoCompanyFile() {
    return this.infoCompanyFiles;
  }

  setInfoCompanyFile(infoCompanyFile) {
    this.infoCompanyFiles = infoCompanyFile;
  }

  getSheetName() {
    return this.sheetName;
  }

  setSheetName(fileName) {
    const file = this.findFile(fileName);

    if (file) {
      this.sheetName = file[0].sheet_name;
    }
  }

  getURLImage() {
    return this.urlImg;
  }

  setURLImage(fileName) {
    const file = this.findFile(fileName);

    if (file) {
      this.urlImg = file[0].portfolio_image;
    }
  }

  getURLFile() {
    return this.urlFile;
  }

  setURLFile(fileName) {
    const file = this.findFile(fileName);

    if (file) {
      this.urlFile = file[0].link_portfolio;
    }
  }
  // Find the selected file
  findFile(fileName) {
    const file = this.infoCompanyFiles
      .find(d => d.file_data.some(dd => dd.file_name === fileName))
      ?.file_data.filter(d => d.file_name === fileName);

    return file;
  }
  // Validate if trade date is required in the information
  validateTradeDate(fileName) {
    const file = this.findFile(fileName);
    let isTradeDate = false;

    if (file) {
      const addiInfo = file[0].additional_info;
      isTradeDate =
        addiInfo && addiInfo.length > 0 && addiInfo.includes("trade date");
    }
    return isTradeDate;
  }
}
